// const site = document.location; const sdom = "crateandbarrel.com.ph"; if (site.hostname != sdom) window.location.assign(`https://${sdom}${site.pathname}`);

function getHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    return match[2];
  }
  else {
    return null;
  }
}

function getDomain(url) {
  var hostName = getHostName(url);
  var domain = hostName;

  if (hostName != null) {
    var parts = hostName.split('.').reverse();

    if (parts != null && parts.length > 1) {
      domain = parts[1] + '.' + parts[0];

      if (hostName.toLowerCase().indexOf('.com.ph') != -1 && parts.length > 2) {
        domain = parts[2] + '.' + domain;
      }
    }
  }

  return domain;
}

const sdom2 = "crateandbarrel.com.ph";
const site2 = document.location; 
const cdom2 = getDomain(site2.href);
const domains2 = ["crateandbarrel.com.ph", "crateandbarrel.ph", "shopifypreview.com", "myshopify.com"];

if (domains2.indexOf(cdom2) < 0) {
  window.location.assign(`https://${sdom2}${site2.pathname}`);
}